export default __webpack_public_path__ + "static/media/craon19.bdb8cd25.jpg";